import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import axios from 'axios';
import './CalendarComponent.css';

const API_KEY = 'AIzaSyCv4WyqIsDhWVzYVbDSafTb0obxWWaJe8E';
const CALENDAR_ID = 'mohit.eway@gmail.com';

function CalendarComponent() {
    const [events, setEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [filteredEvents, setFilteredEvents] = useState([]);

    useEffect(() => {
        const fetchEvents = async () => {
            const now = new Date().toISOString();
            const url = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${API_KEY}&timeMin=${now}&singleEvents=true&orderBy=startTime`;

            try {
                const res = await axios.get(url);
                setEvents(res.data.items);
            } catch (err) {
                console.error("Failed to fetch events", err);
            }
        };

        fetchEvents();
    }, []);

    useEffect(() => {
        const selected = events.filter(event => {
            const eventDate = new Date(event.start.date || event.start.dateTime);
            return (
                eventDate.toDateString() === selectedDate.toDateString()
            );
        });
        setFilteredEvents(selected);
    }, [selectedDate, events]);

    return (
        <div className="calendar-container">

            <div className="calendar-left">
                <h2>Vaishnava Calendar</h2>
                <Calendar
                    onChange={setSelectedDate}
                    value={selectedDate}
                    tileClassName={({ date }) => {
                        const match = events.find(event => {
                            const eventDate = new Date(event.start.date || event.start.dateTime);
                            return eventDate.toDateString() === date.toDateString();
                        });
                        return match ? 'event-day' : null;
                    }}
                />
            </div>

            <div className="calendar-right">
                <h3>{selectedDate.toDateString()}</h3>
                {filteredEvents.length > 0 ? (
                    filteredEvents.map(event => (
                        <div key={event.id} className="event-box">
                            <strong>{event.summary}</strong>
                            <p>{event.description}</p>
                        </div>
                    ))
                ) : (
                    <p>No events on this date.</p>
                )}
            </div>
        </div>
    );
}
export default CalendarComponent;
